module.exports = __webpack_public_path__ + "static/media/galerija_2013 (15).b5ff8c18.JPG";